export default __webpack_public_path__ + "static/media/facebook.9895e357.svg";